import { Html } from '@react-three/drei';
import { useMemo } from 'react';
import * as THREE from 'three';
import styles from './axis-labels.module.scss';
import { format0 } from '../../utils/number';

// Axis labels component
export const AxisLabels = ({
  axis,
  origin,
  dimension,
  divisionUnit,
  labelOffset,
  axisName,
  showAxisName = false,
  showAxisValue = true,
}: {
  axis: 'x' | 'y' | 'z';
  origin: { x: number; y: number; z: number };
  dimension: number;
  divisionUnit: number;
  labelOffset: { x: number; y: number; z: number };
  axisName: string;
  showAxisName?: boolean;
  showAxisValue?: boolean;
}) => {
  const labelPositions = useMemo(() => {
    const positions: { position: THREE.Vector3; value: number }[] = [];
    const lineCount = Math.floor(dimension / divisionUnit);

    for (let i = 0; i <= lineCount; i++) {
      const offset = i * divisionUnit;
      const value = origin[axis] + offset;
      const coords = { ...origin };
      coords[axis] += offset;

      positions.push({
        position: new THREE.Vector3(
          coords.x + labelOffset.x,
          coords.y + labelOffset.y,
          coords.z + labelOffset.z
        ),
        value,
      });
    }

    return positions;
  }, [axis, origin, dimension, divisionUnit, labelOffset]);

  return (
    <>
      {showAxisValue &&
        labelPositions.map((item, i) => {
          return (
            <Html key={`${axis}-${i}`} position={item.position}>
              <div className={styles.axisValue}>{format0(item.value)}</div>
            </Html>
          );
        })}
      {showAxisName && (
        <Html
          position={
            new THREE.Vector3(
              origin.x + (axis === 'x' ? dimension / 2 : 0) + labelOffset.x,
              origin.y + (axis === 'y' ? dimension / 2 : 0) + labelOffset.y,
              origin.z + (axis === 'z' ? dimension / 2 : 0) + labelOffset.z
            )
          }
        >
          <div className={styles.axisLabel}>{axisName}</div>
        </Html>
      )}
    </>
  );
};
